<template>
  <LeftSidebar
    :visible="visible"
    baseClass=""
    :title="$lang.addPerson"
    :hasHeaderRightIcon="false"
  >
    <template>
      <b-row class="margin-0" v-if="visible">
        <b-col cols="12" class="padding-16">
          <Input
            :title="$lang.personCenterExecutiveCode"
            :label="$lang.personCenterExecutiveCode"
            :placeholder="$lang.personCenterExecutiveCode"
            :value="form.personCenterExecutiveCode"
            name="personCenterExecutiveCode"
            id="personCenterExecutiveCode"
            type="text"
            :vuelidateObj="$v.form.personCenterExecutiveCode"
            @input="input"
            @focus="resetValidation"
            @blur="checkValidation"
          />
          <Dropdown
            :title="$lang.personCenterExecutiveExecutive"
            :label="$lang.personCenterExecutiveExecutive"
            :placeholder="$lang.personCenterExecutiveExecutive"
            :infoTooltip="$lang.personCenterExecutiveExecutiveTooltip"
            :value="form.personCenterExecutiveExecutive"
            name="personCenterExecutiveExecutive"
            id="personCenterExecutiveExecutive"
            :vuelidateObj="$v.form.personCenterExecutiveExecutive"
            :asyncSearch="getExecutivesCombo"
            :insideFeature="true"
            @input="input"
            @focus="resetValidation"
            @blur="checkValidation"
          />
          <EnumDropdown
            :title="$lang.executiveRole"
            :label="$lang.executiveRole"
            :placeholder="$lang.executiveRole"
            :value="form.executiveRole"
            name="executiveRole"
            id="executiveRole"
            categoryName="competency_score"
            :vuelidateObj="$v.form.executiveRole"
            :parentOptions="executiveRoleOptions"
            rowClass=""
            @input="input"
            @focus="resetValidation"
            @blur="checkValidation"
          />
        </b-col>
      </b-row>
    </template>
    <template #footer>
      <Button
        variant="filled-complementary"
        :text="$lang.cancel"
        class="mobile-width-percent-100 tablet-width-percent-100"
        contentClass="justify-content-center"
        @click="handleClose"
      />
      <Button
        v-if="checkPermission(PERMISSIONS, ['admin', 'edit'])"
        variant="primary"
        :text="$lang.submit"
        class="mobile-width-percent-100 tablet-width-percent-100"
        contentClass="justify-content-center"
        :loading="loading"
        @click="handleSubmit"
      />
    </template>
  </LeftSidebar>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import { LeftSidebar } from "@/components/re-design";
import {
  Input,
  Dropdown,
  EnumDropdown,
  Button,
} from "@/components/re-design/forms";
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import {
  generateError,
  renderEumOptions,
  toastAlert,
  checkPermission,
} from "@/shared/utils";
import { getExecutivesCombo } from "@/services";
import { addCenterExecutePerson } from "@/modules/kanoon/services";
export default {
  mixins: [inputMixin],
  inject: ["CENTER_EXECUTE_DATA", "PERMISSIONS", "handleReloadList"],
  components: { LeftSidebar, Input, Dropdown, EnumDropdown, Button },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  validations() {
    return {
      form: {
        personCenterExecutiveCode: { required },
        personCenterExecutiveExecutive: { required },
        executiveRole: { required },
      },
    };
  },
  data() {
    return {
      form: {
        personCenterExecutiveCode: null,
        personCenterExecutiveExecutive: null,
        executiveRole: null,
      },
      loading: false,
    };
  },
  computed: {
    executiveRoleOptions() {
      const options = renderEumOptions("executive_role", true);
      return options.filter(({ id }) => id > 2);
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler() {
        this.resetForm();
      },
    },
  },
  methods: {
    getExecutivesCombo,
    checkPermission,
    handleClose() {
      this.$emit("handleClose");
    },
    async handleSubmit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      try {
        this.loading = true;
        const { id: centerExecuteId } = this.CENTER_EXECUTE_DATA;
        const { personCenterExecutiveCode } = this.form;
        const personCenterExecutiveExecutiveCode = pathOr(
          null,
          ["personCenterExecutiveExecutive", "id"],
          this.form
        );
        const executiveRoleId = pathOr(
          null,
          ["executiveRole", "id"],
          this.form
        );
        const response = await addCenterExecutePerson({
          centerExecuteId,
          personCenterExecutiveCode,
          personCenterExecutiveExecutiveCode,
          executiveRoleId,
        });
        const { message } = response;
        toastAlert(message);
        this.handleClose();
        this.handleReloadList();
      } catch (error) {
        generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
